var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiBuilder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4303_1230)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4303_1230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.164 4.67694C42.2697 3.01874 38.7133 3.01874 35.819 4.67694L13.0004 17.7501C11.1342 18.8193 9.98304 20.8055 9.98304 22.9562V28.168C9.98304 30.3188 8.83188 32.305 6.96572 33.3741L5.01732 34.4904C3.15116 35.5596 2 37.5458 2 39.6965V60.0815C2 62.2399 3.15931 64.2319 5.03595 65.2982L36.049 82.9192C41.3822 85.9494 48.0011 82.0973 48.001 75.9634L48 9.57021C48 7.54871 46.918 5.68185 45.164 4.67694Z",
    fill: "url(#paint0_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.164 4.67694C42.2697 3.01874 38.7133 3.01874 35.819 4.67694L13.0004 17.7501C11.1342 18.8193 9.98304 20.8055 9.98304 22.9562V28.168C9.98304 30.3188 8.83188 32.305 6.96572 33.3741L5.01732 34.4904C3.15116 35.5596 2 37.5458 2 39.6965V60.0815C2 62.2399 3.15931 64.2319 5.03595 65.2982L36.049 82.9192C41.3822 85.9494 48.0011 82.0973 48.001 75.9634L48 9.57021C48 7.54871 46.918 5.68185 45.164 4.67694Z",
    fill: "url(#paint1_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.164 4.67694C42.2697 3.01874 38.7133 3.01874 35.819 4.67694L13.0004 17.7501C11.1342 18.8193 9.98304 20.8055 9.98304 22.9562V28.168C9.98304 30.3188 8.83188 32.305 6.96572 33.3741L5.01732 34.4904C3.15116 35.5596 2 37.5458 2 39.6965V60.0815C2 62.2399 3.15931 64.2319 5.03595 65.2982L36.049 82.9192C41.3822 85.9494 48.0011 82.0973 48.001 75.9634L48 9.57021C48 7.54871 46.918 5.68185 45.164 4.67694Z",
    fill: "url(#paint2_radial_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 39.7234C48.0001 41.8824 46.8401 43.8749 44.9626 44.941L21.0447 58.5213C19.1634 59.5895 18.0028 61.5877 18.0072 63.7511L18.0353 77.6583C18.0396 79.8047 19.1902 81.7853 21.0526 82.8523L35.8498 91.3299C38.7364 92.9837 42.2832 92.9841 45.1701 91.3308C46.9204 90.3285 48.0001 88.4659 48.0001 86.449V30V39.7234Z",
    fill: "url(#paint3_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 39.7234C48.0001 41.8824 46.8401 43.8749 44.9626 44.941L21.0447 58.5213C19.1634 59.5895 18.0028 61.5877 18.0072 63.7511L18.0353 77.6583C18.0396 79.8047 19.1902 81.7853 21.0526 82.8523L35.8498 91.3299C38.7364 92.9837 42.2832 92.9841 45.1701 91.3308C46.9204 90.3285 48.0001 88.4659 48.0001 86.449V30V39.7234Z",
    fill: "url(#paint4_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0171 22.9562C86.0171 20.8055 84.8659 18.8193 82.9998 17.7501L60.181 4.67692C57.2868 3.01873 53.7304 3.01874 50.8362 4.67692C49.0821 5.68184 48.0001 7.54872 48.0001 9.57024V72.6983L52.5259 75.2912C54.3735 76.3497 56.6437 76.3497 58.4913 75.2912L82.9998 61.2499C84.8659 60.1807 86.0171 58.1945 86.0171 56.0438V22.9562Z",
    fill: "url(#paint5_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0171 22.9562C86.0171 20.8055 84.8659 18.8193 82.9998 17.7501L60.181 4.67692C57.2868 3.01873 53.7304 3.01874 50.8362 4.67692C49.0821 5.68184 48.0001 7.54872 48.0001 9.57024V72.6983L52.5259 75.2912C54.3735 76.3497 56.6437 76.3497 58.4913 75.2912L82.9998 61.2499C84.8659 60.1807 86.0171 58.1945 86.0171 56.0438V22.9562Z",
    fill: "url(#paint6_radial_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0175 24.7503C69.865 23.6918 72.1352 23.6918 73.9828 24.7503L90.9828 34.4899C92.849 35.5591 94.0001 37.5453 94.0001 39.696V60.0953C94.0001 62.2461 92.849 64.2323 90.9828 65.3014L71.0001 76.7498L48.0001 63.5728V39.696C48.0001 37.5453 49.1513 35.5591 51.0174 34.4899L68.0175 24.7503Z",
    fill: "url(#paint7_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0175 24.7503C69.865 23.6918 72.1352 23.6918 73.9828 24.7503L90.9828 34.4899C92.849 35.5591 94.0001 37.5453 94.0001 39.696V60.0953C94.0001 62.2461 92.849 64.2323 90.9828 65.3014L71.0001 76.7498L48.0001 63.5728V39.696C48.0001 37.5453 49.1513 35.5591 51.0174 34.4899L68.0175 24.7503Z",
    fill: "url(#paint8_radial_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9987 39.723C47.9987 41.8821 49.1587 43.8747 51.0362 44.9407L74.9551 58.521C76.8365 59.5892 77.9971 61.5876 77.9926 63.7511L77.9637 77.6583C77.9593 79.8046 76.8087 81.785 74.9464 82.852L60.1489 91.3297C57.2623 92.9835 53.7156 92.9838 50.8286 91.3306C49.0784 90.3283 47.9987 88.4657 47.9987 86.4488V33V39.723Z",
    fill: "url(#paint9_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9987 39.723C47.9987 41.8821 49.1587 43.8747 51.0362 44.9407L74.9551 58.521C76.8365 59.5892 77.9971 61.5876 77.9926 63.7511L77.9637 77.6583C77.9593 79.8046 76.8087 81.785 74.9464 82.852L60.1489 91.3297C57.2623 92.9835 53.7156 92.9838 50.8286 91.3306C49.0784 90.3283 47.9987 88.4657 47.9987 86.4488V33V39.723Z",
    fill: "url(#paint10_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9987 39.723C47.9987 41.8821 49.1587 43.8747 51.0362 44.9407L74.9551 58.521C76.8365 59.5892 77.9971 61.5876 77.9926 63.7511L77.9637 77.6583C77.9593 79.8046 76.8087 81.785 74.9464 82.852L60.1489 91.3297C57.2623 92.9835 53.7156 92.9838 50.8286 91.3306C49.0784 90.3283 47.9987 88.4657 47.9987 86.4488V33V39.723Z",
    fill: "url(#paint11_linear_4303_1230)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4303_1230",
    x1: 37,
    y1: 78,
    x2: 31,
    y2: 1.99999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D35B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635285,
    stopColor: "#2052CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4303_1230",
    x1: 33.5,
    y1: 29.5,
    x2: 48,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2052CB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D35B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4303_1230",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43 59.5) rotate(147.995) scale(56.6039 33.2324)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357677,
    stopColor: "#312A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2052CB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4303_1230",
    x1: 41.5001,
    y1: 94,
    x2: 35.3404,
    y2: 50.0224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5750E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367AF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4303_1230",
    x1: 38.5001,
    y1: 73,
    x2: 48.0001,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2764E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A43CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4303_1230",
    x1: 69.0001,
    y1: 2,
    x2: 61.5001,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4894FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4303_1230",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.5001 39) rotate(-90) scale(25.5 51.9104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.293088,
    stopColor: "#2764E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FAFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4303_1230",
    x1: 74.0001,
    y1: 25.4996,
    x2: 66.0001,
    y2: 71.4996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4894FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4303_1230",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0001 54.4996) rotate(-58.2986) scale(19.9812 82.6434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29C3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4303_1230",
    x1: 60.0001,
    y1: 47.5,
    x2: 58.3868,
    y2: 94.1345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58AAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4303_1230",
    x1: 59.0001,
    y1: 63,
    x2: 52.0001,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4303_1230",
    x1: 56.5001,
    y1: 71,
    x2: 48.0001,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4303_1230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4303_1230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBuilder);
export default __webpack_public_path__ + "static/media/ai-builder.baea8ab1dbbc545b50ede511bbb53d37.svg";
export { ForwardRef as ReactComponent };